// Token-shape classifiers for the public /play/{token} URL.
// match_id  = UUID v7 string (canonical identity, contract §0/§5.1)
// discordId = Discord snowflake (legacy public id, demoted to attribute, contract §0)
// The two classes are disjoint, so a router guard can branch unambiguously.

const MATCH_ID_RE = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
const DISCORD_ID_RE = /^\d{15,22}$/;

export function isMatchId(token) {
  return typeof token === 'string' && MATCH_ID_RE.test(token);
}

export function isDiscordId(token) {
  return typeof token === 'string' && DISCORD_ID_RE.test(token);
}
